<template>
  <div class="flow-detail">
    <el-timeline>
      <el-timeline-item
        :hide-timestamp="true"
        v-for="(item, index) in approvalLogs"
        :key="index"
        placement="top"
      >
        <template #dot>
          <div class="edit-info-dot" />
        </template>
        <div class="title tw-flex tw-items-center">
          <span class="text-333 tw-mr-2">{{ item.nodeName }}</span>
          <span class="tw-mr-2 text-aaa" v-if="+item.totalNum">
            {{ `(${item.doneNum}/${item.totalNum})` }}
          </span>
          <el-tag v-if="item.tag" size="small" type="info">{{ TagName[item.tag] }}</el-tag>
        </div>
        <div class="tw-flex tw-my-[16px] tw-items-center" v-for="(log, i) in item?.logs" :key="i">
          <span class="text-666 tw-mr-[10px]" v-if="log.levelName">{{ log.levelName }}</span>
          <StatusIcon class="tw-mr-[10px]" :status="log.action" />
          <span class="text-666 tw-mr-[10px]">{{ info?.userRealNameMap[log.operator] }}</span>
          <el-tag
            :type="getStatus(log.action).type"
            class="tw-mr-[10px]"
            v-if="getStatus(log.action).name"
          >
            {{ getStatus(log.action).name }}
          </el-tag>
          <span class="text-666 tw-mr-[10px]">{{ info.userRealNameMap[log.content] }}</span>
          <span class="text-666 tw-mr-[10px]">{{ log.comment }}</span>
          <span class="text-aaa">{{ log.updateTime }}</span>
        </div>
        <!--     抄送-->
        <div v-if="item?.ccOperators?.length">
          <div class="tw-mt-[10px]" v-for="(cc, index) in item.ccOperators" :key="index">
            <span class="text-aaa tw-mr-[10px]">抄送：</span>
            <span class="text-666 tw-mr-[10px]">{{ info?.userRealNameMap[cc] }}</span>
            <span class="text-aaa tw-ml-[40px]">{{ item.createTime }}</span>
          </div>
        </div>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { ApproveStatus, StatusOptions } from '@/enums/flow'
import StatusIcon from './StatusIcon.vue'

const props = defineProps({
  info: {
    type: Object,
    default: () => ({})
  }
})

const TagName = {
  CANCEL: '撤回',
  ANY_APPROVAL: '或签',
  LEVEL_APPROVAL: '逐级审批'
}

const approvalLogs = computed(() => {
  let list = props?.info?.approvalLogs || []
  let arr: Recordable[] = []
  const finishTypes = ['PASS', 'REJECT', 'CANCEL', 'CLOSE']
  if (finishTypes.includes(props?.info?.processState)) {
    arr = [
      {
        nodeName: '流程结束'
      }
    ]
  }
  return list.concat(arr)
})

function getStatus(status: ApproveStatus) {
  return StatusOptions[status] || {}
}
</script>
<style lang="scss" scoped>
.flow-detail {
  padding: 10px 3px;
  :deep(.el-timeline-item__dot) {
    top: -5px;
    left: -3px;
  }
  :deep(.el-timeline-item__tail) {
    border-color: #5687ff;
  }
  .title {
    margin: 0;
  }
}
.edit-info-dot {
  width: 16px;
  height: 16px;
  background: var(---, #5687ff);
  border: 4px solid #fff;
  border-radius: 8px;
}

.text-aaa {
  color: #aaaaaa;
  font-size: 12px;
}

.text-333 {
  color: #333333;
  font-size: 14px;
}

.text-666 {
  color: #666666;
  font-size: 14px;
  font-style: normal;
}
.status-tag {
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 12px;
}
.icon-tag {
  font-size: 16px;
}

.text-tag {
  border-width: 1px;
  border-style: solid;
  border-radius: 16px;
}
:deep(.el-tag) {
  border: none;
}
</style>
